module.exports = __webpack_public_path__ + "img/semi-vector.d6a8f682.png";